import Decimal from 'decimal.js-light';
import * as geolib from 'geolib';

import type { LonLat } from '@/types';

export const convertMeters = (distance: number | null): string => {
  if (distance == null) return '0';

  return distance < 1000
    ? Math.floor(distance).toString()
    : new Decimal(distance).dividedBy(1000).toDecimalPlaces(1).toFixed(1);
};

export const calcDistance = (location: LonLat, geoPoint: LonLat): number => {
  if (
    !location?.latitude ||
    !location?.longitude ||
    !geoPoint?.latitude ||
    !geoPoint?.longitude
  ) {
    return 0;
  }

  const distance = geolib.getDistance(
    { latitude: location.latitude, longitude: location.longitude },
    { latitude: geoPoint.latitude, longitude: geoPoint.longitude },
    0.01
  );

  return distance;
};
